import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import Chip from '../base/Chip'

type Props = {
  onClick: () => void
}

const ClearFilters = ({ onClick }: Props) => {
  return (
    <Chip
      label={
        <Box gap="s4" flexDirection="row" alignItems="center">
          <Icon.Small icon="close" color="grey700" />
          <Text.Normal size="200" color="grey700">
            {i18n.t('filters.clear_filter')}
          </Text.Normal>
        </Box>
      }
      onClick={onClick}
      active={false}
      hideChevron
      noBorder
    />
  )
}

export default ClearFilters
